import { create } from 'zustand';
// Memory only. Never persist signup credentials or pending social tokens.
export const useSignupDraft = create((set) => ({
  credentials: null,
  socialToken: null,
  setSocialToken: (socialToken) => set({ credentials: null, socialToken }),
  setCredentials: (credentials) => set({ credentials, socialToken: null }),
  clear: () => set({ credentials: null, socialToken: null }),
}));
export function removeLegacyDraft() {
  ['signup_email', 'signup_password', 'social_signup_token'].forEach((key) =>
    sessionStorage.removeItem(key),
  );
}
